import { makeTestIds } from "@ctra/utils";

/**
 * Make test ids for ask ida
 */
export const testIds = makeTestIds("askIda", {
  createTracker: {
    wizard: {
      close: "close",
      container: "container",
      configureWidget: {
        submit: "submit",
        addRow: "addRow",
        row: "row",
        trash: "trash"
      },
      kpiSelect: {
        kpiDropdown: "kpiDropdown",
        changeDirectionDropdown: "changeDirectionDropdown",
        datePicker: "datePicker"
      },
      summary: {
        submit: "submit",
        title: "title",
        description: "description"
      },
      activateInsight: {
        cta: "cta"
      }
    },
    modal: {
      desktop: "desktop",
      mobile: "mobile"
    },
    question: {
      rollback: "rollback"
    }
  },
  entity: {
    wrapper: "wrapper",
    change: {
      switch: "switch",
      title: "title",
      description: "description"
    },
    details: {
      wrapper: "wrapper",
      mobile: {
        wrapper: "wrapper"
      },
      desktop: {
        wrapper: "wrapper"
      }
    }
  }
});
